import { useEffect, useState } from "react";
import { Table, Spin, Typography } from "antd";
import { getLineasActaPO } from "../../../../services/financiero/ingresosPO/entregasPOService";

const { Text } = Typography;

export default function EntregaLineasExpand({ record }) {

  const [loading, setLoading] = useState(true);
  const [lineas, setLineas] = useState([]);

  useEffect(() => {
    let activo = true;
    setLoading(true);
    getLineasActaPO({
      oid_participante: record.oid_participante,
      tipo_entrega: record.tipo_entrega,
      fecha_entrega: record.fecha_entrega,
      oid_bodega: record.oid_bodega
    })
      .then((data) => { if (activo) setLineas(data); })
      .catch(() => { if (activo) setLineas([]); })
      .finally(() => { if (activo) setLoading(false); });
    return () => { activo = false; };
  }, [record.oid_participante, record.tipo_entrega, record.fecha_entrega, record.oid_bodega]);

  const columns = [
    {
      title: "Producto",
      dataIndex: "nombre_producto",
      render: (value, row) => <Text>{row.nombre_corto || value}</Text>
    },
    { title: "Tipo", dataIndex: "tipo_producto", width: 200 },
    { title: "Cantidad", dataIndex: "cantidad", width: 110, align: "center" },
    { title: "Unidad", dataIndex: "unidad_medida", width: 130 }
  ];

  return (
    <Spin spinning={loading}>
      <Table
        rowKey="oid"
        size="small"
        columns={columns}
        dataSource={lineas}
        pagination={false}
        style={{ margin: "8px 0 8px 24px" }}
      />
    </Spin>
  );
}
